<template>
  <div id="body">
    <b-row>
      <b-col sm="10">
        <b-input-group prepend="url" >
          <b-form-input v-model="url"/>
        </b-input-group>
      </b-col>
      <b-col sm="2">
        <b-button variant="primary" @click="crawlItem">
          검색
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10" v-if="price">
        <b-input-group prepend="이름" >
          <b-form-input v-model="name" />
        </b-input-group>
        <ul>
          <li v-for="item in similar_list" :key="item._id">{{item.name}}</li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4" v-if="price">
        <b-input-group prepend="종류" >
          <b-form-select 
            v-model="category" 
            :options="category_list"
            value-field="_id"
            text-field="name"
          >
          </b-form-select>
        </b-input-group>
        <b-input-group prepend="브랜드" >
          <b-form-input v-model="brand" />
        </b-input-group>
        <b-input-group prepend="타입" >
          <b-form-select 
            v-model="type" 
            :options="type_list"
          >
          </b-form-select>
        </b-input-group>
        <b-input-group :prepend="nutri_id" >
          <b-form-input type='number' v-model="nutri_amount" />
        </b-input-group>
        <b-input-group prepend="용량" >
          <b-form-input type='number' v-model="amount" />
        </b-input-group>
        <b-input-group prepend="일일 권장량" >
          <b-form-input type='number' v-model="daily_amount" />
        </b-input-group>
      </b-col>
      <b-col sm="4" v-if="price">
        <b-input-group prepend="가격" >
          <b-form-input type='number' v-model="price.price" />
        </b-input-group>
        <b-input-group prepend="배송비" >
          <b-form-input type='number' v-model="price.ship" />
        </b-input-group>
        <b-input-group prepend="수량" >
          <b-form-input type='number' v-model="price.amount" />
        </b-input-group>
        <b-input-group prepend="사이트" >
          <b-form-input v-model="price.mall" />
        </b-input-group>
        <b-button class="float-right" @click="submit">등록</b-button>
      </b-col>
    </b-row>
    <b-modal id="modal-1" size="xl">
      <iframe :src="url"/>
    </b-modal>
  </div>
</template>

<script>
import util from '../util'
import {
    BRow, BCol, BCard, BModal,
    BForm, BFormGroup, BFormInput, BInputGroup, BFormSelect, BButton,
    BIconArrowClockwise
} from 'bootstrap-vue'

export default {
  name: 'NewComponent',
  components: {
    BRow, BCol, BCard, BModal,
    BForm, BFormGroup, BFormInput, BInputGroup, BFormSelect, BButton,
    BIconArrowClockwise
  },
  data () {
    return {
      url: null,
      price: null,
      name: null,
      category: null,
      category_list: [],
      nutri_list: [],
      nutri_id: null,
      nutri_amount: 0,
      brand_list: [],
      brand: null,
      brand_id: null,
      amount: 0,
      daily_amount: 0,
      similar_list: [],
      type: 0,
      type_list: [
        {value: 0, text: '캡슐,정'}, {value:1, text: '분말'}, {value:2, text: '음료'},
        {value: 3, text: '캔디'}, {value: 4, text: '젤리'}, {value: 5, text: '환'}, 
        {value: 6, text: '액상'}, {value: 7, text: '스프레이'}]
    }
  },
  created() {
    this.get_category_list()
    this.get_nutri_list()
    this.get_brand_list()
  },
  computed: {
  },
  watch: {
    category (v) {
      if (v) {
        let category_item = this.category_list.filter(a => a._id==v)[0]
        this.nutri_id = category_item.nutritions[0].replace('!', '')
      }
    }
  },
  methods: {
    get_nutri_list() {
      util.get('nutrition').then(res => {
        this.nutri_list = res.data
      })
    },
    get_brand_list() {
      util.get('brand').then(res => {
        this.brand_list = res.data
      })
    },
    get_category_list() {
      util.get('category').then(res => {
        this.category_list = res.data
      })
    },
    searchItem () {
      util.get(`item/search/${encodeURIComponent(this.name)}`).then(res => {
        this.similar_list = res.data.slice(0, 5)
        console.log(this.similar_list)
      }).catch(err => {
        console.log(err)
      })
    },
    crawlItem () {
      if (this.url != '') {
        util.get_to_crawl('price_info', {
          link: this.url
        }).then(res => {
          this.price = res.data
          this.price.amount = 1
          this.price.link = this.url
          this.name = this.price.name
          this.category_list.map(category => {
            if (this.name.includes(category.name)) {
              this.category = category._id
            }
          })
          Object.entries(this.brand_list).map(brand => {
            if (this.name.includes(brand[1].name)) {
              this.brand = brand[1].name
              if (brand[1].engname) {
                this.brand += brand[1].engname
              }
              this.brand_id = brand[0]
            }
          })
          this.searchItem()
        })
      }
    },
    submit() {
      util.post_to_crawl('add_item', {
        name: this.name,
        category: this.category,
        brand: this.brand,
        type: this.type,
        amount: Number(this.amount),
        daily_amount: Number(this.daily_amount),
        nutritions: {[this.nutri_id]: Number(this.nutri_amount)},
        price: this.price
      }).then(res => {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#body {
  padding: 20px;
  height: 70vh;
}

div.row {
  margin: 20px 0;
}
div.row.result {
  height: 100vh;
}
.modal-dialog {
  max-width: 100% !important;
}
iframe {
  width: 120%;
  height: 50vh;
  -ms-zoom: 0.75;
  -moz-transform: scale(0.75);
  -moz-transform-origin: 0 0;
  -o-transform: scale(0.75);
  -o-transform-origin: 0 0;
  -webkit-transform: scale(0.75);
  -webkit-transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/New.vue